/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Customer
 *
 * 2 = Auction
 */
export enum TypeReport {
  Customer = 1,
  Auction = 2,
}
